import { utcToLocal } from '../helpers/utils';

export const LAST_UPDATED_COLUMN = {
  Header: 'Updated',
  accessor: 'updated_at',
  Cell: ({ cell: { value } }: { cell: { value: string } }) => {
    if (!value) return null;
    const parsed = utcToLocal(value);
    if (!parsed.isValid()) return null;
    return <p>{parsed.fromNow()}</p>;
  },
};

export const DEADLINE_OPTIONS = [
  { value: 1, label: 'Today' },
  { value: 7, label: '7 days' },
  { value: 14, label: '14 days' },
  { value: 30, label: '30 days' },
  { value: 90, label: '90 days' },
  { value: 365, label: 'YTD' },
  { value: 2, label: 'Fiscal Year' },
  { value: 0, label: 'All' },
];

export const ACTIVE_OPTIONS = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
];

export const nameFromArray = (value: any, array: any[]): string | undefined =>
  array.find(({ id }) => id === value)?.name;
